import { useMutation } from "react-query";
import downloadSkuPoCsv from "../services/downloadSkuPoOcrCsv";

function useDownloadSkuPoOcrCsv() {
  return useMutation(["download-sku-po-ocr-csv"], downloadSkuPoCsv);
}

export default useDownloadSkuPoOcrCsv;
